export default __webpack_public_path__ + "assets/crystal-fafaa53ccd5d7b3e58acd23af0775e24.svg";